// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.Contacts-module__font-s-10___dTxB_ {
  font-size: 10px !important;
}

.Contacts-module__font-s-12___kMUAT {
  font-size: 12px !important;
}

.Contacts-module__font-s-13___pVCA8 {
  font-size: 13px !important;
}

.Contacts-module__font-s-14___uoVcI {
  font-size: 14px !important;
}

.Contacts-module__font-s-15___iCfW4 {
  font-size: 15px !important;
}

.Contacts-module__font-s-16___nynmc {
  font-size: 16px !important;
}

.Contacts-module__font-s-18___Ba5pN {
  font-size: 18px !important;
}

.Contacts-module__font-s-20___t7Ql8 {
  font-size: 20px !important;
}

.Contacts-module__font-s-22___yF26Z {
  font-size: 22px !important;
}

.Contacts-module__font-s-28___i9XM0 {
  font-size: 28px !important;
}

.Contacts-module__font-w-400___chQ9C {
  font-weight: 400 !important;
}

.Contacts-module__font-w-500___YSarm {
  font-weight: 500 !important;
}

.Contacts-module__font-w-600___rmu7r {
  font-weight: 600 !important;
}

.Contacts-module__font-w-700___pHpAg {
  font-weight: 700 !important;
}

.Contacts-module__p-5___kurs7 {
  padding: 5px !important;
}

.Contacts-module__p-12___woYUp {
  padding: 12px !important;
}

.Contacts-module__p-16___Xrj6m {
  padding: 16px !important;
}

.Contacts-module__p-30___x5k78 {
  padding: 30px !important;
}

.Contacts-module__p-b-0___tho9A {
  padding-bottom: 0 !important;
}

.Contacts-module__p-b-5___oN6We {
  padding-bottom: 5px !important;
}

.Contacts-module__p-b-10___uk488 {
  padding-bottom: 10px !important;
}

.Contacts-module__p-b-12___h96G4 {
  padding-bottom: 12px !important;
}

.Contacts-module__p-b-16___uvvDh {
  padding-bottom: 16px !important;
}

.Contacts-module__p-b-18___vcST3 {
  padding-bottom: 18px !important;
}

.Contacts-module__p-b-20___WeC2o {
  padding-bottom: 20px !important;
}

.Contacts-module__p-b-25___qcF5Y {
  padding-bottom: 25px !important;
}

.Contacts-module__p-b-30___XNEST {
  padding-bottom: 30px !important;
}

.Contacts-module__p-b-50____LH6d {
  padding-bottom: 50px !important;
}

.Contacts-module__p-t-0___ioSxG {
  padding-top: 0 !important;
}

.Contacts-module__p-t-12___F__MH {
  padding-top: 12px !important;
}

.Contacts-module__p-t-16___ojqiQ {
  padding-top: 16px !important;
}

.Contacts-module__p-t-18___WV29x {
  padding-top: 18px !important;
}

.Contacts-module__p-t-20___QQunH {
  padding-top: 20px !important;
}

.Contacts-module__p-t-30___sHV35 {
  padding-top: 30px !important;
}

.Contacts-module__p-t-40___fka4m {
  padding-top: 40px !important;
}

.Contacts-module__p-t-50___D5r6Q {
  padding-top: 50px !important;
}

.Contacts-module__p-l-20___bseIP {
  padding-left: 20px !important;
}

.Contacts-module__p-l-30___w0vtR {
  padding-left: 30px !important;
}

.Contacts-module__p-l-40___ysIcg {
  padding-left: 40px !important;
}

.Contacts-module__p-r-16___YRmPG {
  padding-right: 16px !important;
}

.Contacts-module__p-r-20___PDmtm {
  padding-right: 20px !important;
}

.Contacts-module__p-r-30___JfdYz {
  padding-right: 30px !important;
}

.Contacts-module__p-r-50___cUTB8 {
  padding-right: 50px !important;
}

.Contacts-module__p-r-60___r6RId {
  padding-right: 60px !important;
}

.Contacts-module__m-b-1___bhWJO {
  margin-bottom: 1px !important;
}

.Contacts-module__m-b-2___uQz9H {
  margin-bottom: 2px !important;
}

.Contacts-module__m-b-6___sDLvL {
  margin-bottom: 6px !important;
}

.Contacts-module__m-b-8___UAmSz {
  margin-bottom: 8px !important;
}

.Contacts-module__m-b-10___oFvcG {
  margin-bottom: 10px !important;
}

.Contacts-module__m-b-14___jXSgZ {
  margin-bottom: 14px !important;
}

.Contacts-module__m-b-16___TBYem {
  margin-bottom: 16px !important;
}

.Contacts-module__m-b-20___SsmDP {
  margin-bottom: 20px !important;
}

.Contacts-module__m-b-22___SExx4 {
  margin-bottom: 22px !important;
}

.Contacts-module__m-b-24___zgkcS {
  margin-bottom: 24px !important;
}

.Contacts-module__m-b-30___DZCTO {
  margin-bottom: 30px !important;
}

.Contacts-module__m-b-32___dsm76 {
  margin-bottom: 32px !important;
}

.Contacts-module__m-b-40___Vg3b9 {
  margin-bottom: 40px !important;
}

.Contacts-module__m-t-2___BsKXe {
  margin-top: 2px !important;
}

.Contacts-module__m-t-3___HN4pW {
  margin-top: 3px !important;
}

.Contacts-module__m-t-4___rGKFm {
  margin-top: 4px !important;
}

.Contacts-module__m-t-5___NdTfu {
  margin-top: 5px !important;
}

.Contacts-module__m-t-8___oR8y3 {
  margin-top: 8px !important;
}

.Contacts-module__m-t-10___TPvZT {
  margin-top: 10px !important;
}

.Contacts-module__m-t-15___UBmkK {
  margin-top: 15px !important;
}

.Contacts-module__m-t-16___iqy3W {
  margin-top: 16px !important;
}

.Contacts-module__m-t-20___r6g9t {
  margin-top: 20px !important;
}

.Contacts-module__m-t-22___S_d77 {
  margin-top: 22px !important;
}

.Contacts-module__m-t-30___QweLQ {
  margin-top: 30px !important;
}

.Contacts-module__m-t-32____bgBz {
  margin-top: 32px !important;
}

.Contacts-module__m-l-auto___VytvD {
  margin-left: auto !important;
}

.Contacts-module__m-l-4___fAKiH {
  margin-left: 4px !important;
}

.Contacts-module__m-l-5___WnKy4 {
  margin-left: 5px !important;
}

.Contacts-module__m-l-6___x1Kpi {
  margin-left: 6px !important;
}

.Contacts-module__m-l-8___ADyIq {
  margin-left: 8px !important;
}

.Contacts-module__m-l-10___Zs7E0 {
  margin-left: 10px !important;
}

.Contacts-module__m-l-16___dpuzX {
  margin-left: 16px !important;
}

.Contacts-module__m-l-20___peoby {
  margin-left: 20px !important;
}

.Contacts-module__m-l-24___akVMZ {
  margin-left: 24px !important;
}

.Contacts-module__m-l-30___DzmGk {
  margin-left: 30px !important;
}

.Contacts-module__m-l-35___b8VC2 {
  margin-left: 35px !important;
}

.Contacts-module__m-l-40___zVzWE {
  margin-left: 40px !important;
}

.Contacts-module__m-r-8___z4zEO {
  margin-right: 8px !important;
}

.Contacts-module__m-r-10___TNs5y {
  margin-right: 10px !important;
}

.Contacts-module__m-r-16___Qe3gf {
  margin-right: 16px !important;
}

.Contacts-module__m-r-20___TGDSi {
  margin-right: 20px !important;
}

.Contacts-module__m-r-24___ZlovK {
  margin-right: 24px !important;
}

.Contacts-module__m-r-30___O5Yc8 {
  margin-right: 30px !important;
}

.Contacts-module__m-r-40____XsFw {
  margin-right: 40px !important;
}

.Contacts-module__border-r-3____oDPj {
  border-radius: 3px !important;
}

.Contacts-module__border-r-4___RVzr9 {
  border-radius: 4px !important;
}

.Contacts-module__border-r-6___COYOl {
  border-radius: 6px !important;
}

.Contacts-module__border-r-10___ReZNR {
  border-radius: 10px !important;
}

.Contacts-module__border-r-12___bxdJG {
  border-radius: 12px !important;
}

.Contacts-module__border-r-16___wucYt {
  border-radius: 16px !important;
}

.Contacts-module__border-r-50___SuuVU {
  border-radius: 50% !important;
}

.Contacts-module__primary-border___Hzbwx {
  border: 1px solid rgba(91, 91, 91, 0.2);
}

.Contacts-module__primary-border-b___yAXz_ {
  border-bottom: 1px solid rgba(91, 91, 91, 0.2);
}

.Contacts-module__primary-border-t___pJFW5 {
  border-top: 1px solid rgba(91, 91, 91, 0.2);
}

.Contacts-module__primary-border-l___GfK1Y {
  border-left: 1px solid rgba(91, 91, 91, 0.2);
}

.Contacts-module__primary-border-r___tCxMF {
  border-right: 1px solid rgba(91, 91, 91, 0.2);
}

.Contacts-module__secondary-border___S8qW9 {
  border: 1px solid #637768;
}

.Contacts-module__secondary-border-b___rmvVb {
  border-bottom: 1px solid #637768;
}

.Contacts-module__secondary-border-t___L3tbP {
  border-top: 1px solid #637768;
}

.Contacts-module__secondary-border-l___cbb8S {
  border-left: 1px solid #637768;
}

.Contacts-module__secondary-border-r___AktX5 {
  border-right: 1px solid #637768;
}

.Contacts-module__gap-0___TxD_p {
  gap: 0 !important;
}

.Contacts-module__gap-2___RZHDW {
  gap: 2px !important;
}

.Contacts-module__gap-4___SCbye {
  gap: 4px !important;
}

.Contacts-module__gap-5___cMpjD {
  gap: 5px !important;
}

.Contacts-module__gap-6___JQlr4 {
  gap: 6px !important;
}

.Contacts-module__gap-8___wVc20 {
  gap: 8px !important;
}

.Contacts-module__gap-10___woTae {
  gap: 10px !important;
}

.Contacts-module__gap-12___ncJVd {
  gap: 12px !important;
}

.Contacts-module__gap-14___AfvKK {
  gap: 14px !important;
}

.Contacts-module__gap-16___sAjZP {
  gap: 16px !important;
}

.Contacts-module__gap-18___V2NXE {
  gap: 18px !important;
}

.Contacts-module__gap-20___qf1MT {
  gap: 20px !important;
}

.Contacts-module__gap-24___EjS08 {
  gap: 24px !important;
}

.Contacts-module__gap-26___LjXIL {
  gap: 26px !important;
}

.Contacts-module__gap-30___RMU1S {
  gap: 30px !important;
}

.Contacts-module__gap-32___FDDET {
  gap: 32px !important;
}

.Contacts-module__gap-40___elrx8 {
  gap: 40px !important;
}

.Contacts-module__gap-50___fa8B8 {
  gap: 50px !important;
}

.Contacts-module__flex-1___czmF5 {
  flex: 1;
}

.Contacts-module__flex-none___rg5q3 {
  flex: none !important;
}

.Contacts-module__flex-column___f3zK4 {
  display: flex;
  flex-direction: column !important;
}

.Contacts-module__flex-row___yPGR4 {
  display: flex;
  flex-direction: row !important;
}

.Contacts-module__vertically-centered___JnD58 {
  display: flex;
  align-items: center !important;
}

.Contacts-module__horizontally-centered___TdSJX {
  display: flex;
  justify-content: center !important;
}

.Contacts-module__horizontally-end___rACcc {
  display: flex;
  justify-content: end !important;
}

.Contacts-module__vertically-start___WXZFv {
  display: flex;
  align-items: start !important;
}

.Contacts-module__space-between____8aWf {
  display: flex;
  justify-content: space-between !important;
}

.Contacts-module__flex-wrap___i2ioB {
  flex-wrap: wrap !important;
}

.Contacts-module__height-100___CC5lC {
  height: 100%;
}

.Contacts-module__width-50___DX4tM {
  width: 50% !important;
}

.Contacts-module__width-100___XDdWK {
  width: 100%;
}

.Contacts-module__cursor-pointer___wIFQe {
  cursor: pointer;
}

.Contacts-module__cursor-not-allowed___i4XEi {
  cursor: not-allowed !important;
}

.Contacts-module__absolute-centered___KbWru {
  top: 50%;
  left: 50%;
  position: absolute;
  transform: translate(-50%, -50%);
}

.Contacts-module__absolute___KYdvk {
  position: absolute;
}

.Contacts-module__relative___pgq7z {
  position: relative;
}

.Contacts-module__fixed___pUUKD {
  position: fixed;
}

.Contacts-module__visible___d4RTI {
  opacity: 1;
}

.Contacts-module__invisible___sretV {
  opacity: 0;
}

.Contacts-module__col-90___LPS8u {
  width: 90% !important;
}

.Contacts-module__col-auto___GiZDh {
  width: auto !important;
}

.Contacts-module__medical-tabs____pBVh {
  gap: 30px;
  padding: 0 !important;
  margin: 20px 40px -5px 40px;
}

.Contacts-module__medical-table-new___D5mkP {
  height: calc(100vh - var(--tabs-navigation) - var(--patient-details-header) - var(--secondary-navigation) - var(--patient-details-footer) - var(--table-tabs) - var(--table-pagination));
  overflow-y: scroll;
  overflow-x: hidden;
}
.Contacts-module__medical-table-new___D5mkP:hover::-webkit-scrollbar-thumb {
  background-color: rgb(125, 123, 121);
  border-radius: 10px;
}
.Contacts-module__medical-table-new___D5mkP::-webkit-scrollbar {
  width: 5px;
  background-color: transparent;
}
.Contacts-module__medical-table-new___D5mkP::-webkit-scrollbar-track {
  display: none;
}
.Contacts-module__medical-table-new___D5mkP.Contacts-module__no-pagination___Ry7oR {
  height: calc(100vh - var(--tabs-navigation) - var(--patient-details-header) - var(--secondary-navigation) - var(--patient-details-footer) - var(--table-tabs));
  overflow-y: scroll;
  overflow-x: hidden;
}
.Contacts-module__medical-table-new___D5mkP.Contacts-module__no-pagination___Ry7oR:hover::-webkit-scrollbar-thumb {
  background-color: rgb(125, 123, 121);
  border-radius: 10px;
}
.Contacts-module__medical-table-new___D5mkP.Contacts-module__no-pagination___Ry7oR::-webkit-scrollbar {
  width: 5px;
  background-color: transparent;
}
.Contacts-module__medical-table-new___D5mkP.Contacts-module__no-pagination___Ry7oR::-webkit-scrollbar-track {
  display: none;
}

.Contacts-module__medical-table-empty___p0kbn {
  padding: 14px 40px !important;
}

.Contacts-module__icon-btn___iJ63s {
  width: 22px;
  height: 22px;
  cursor: pointer;
}

.Contacts-module__search-icon___rVWVu {
  width: 24px;
  height: 24px;
  align-self: center;
}

.Contacts-module__disable-select___ZcfT0 {
  user-select: none;
}

.Contacts-module__break-word___Mm52r {
  word-break: break-word;
}

.Contacts-module__popup-clear-btn___GQYFq {
  display: flex;
  align-self: center;
  cursor: pointer;
  font-weight: 500;
  font-size: 14px;
  line-height: 150%;
  color: #f06c67;
}

.Contacts-module__scroll-m-b-20___eVjve {
  scroll-margin-bottom: 20px;
}

.Contacts-module__article___FZan8 {
  padding: 27px 24px;
  height: calc(100vh - var(--top-navigation) - var(--patient-details-header) - var(--patient-details-footer));
  overflow-y: scroll;
  overflow-x: hidden;
}
.Contacts-module__article___FZan8:hover::-webkit-scrollbar-thumb {
  background-color: rgb(125, 123, 121);
  border-radius: 10px;
}
.Contacts-module__article___FZan8::-webkit-scrollbar {
  width: 5px;
  background-color: transparent;
}
.Contacts-module__article___FZan8::-webkit-scrollbar-track {
  display: none;
}
.Contacts-module__article___FZan8 .Contacts-module__acccordion____f03t {
  width: 70%;
}`, "",{"version":3,"sources":["webpack://./../common/src/styles/global/_base.scss","webpack://./src/pages/PatientDetails/fragments/Contacts/Contacts.module.scss","webpack://./../common/src/styles/global/_mixins.scss"],"names":[],"mappings":"AAIA;EACE,0BAAA;ACHF;;ADMA;EACE,0BAAA;ACHF;;ADMA;EACE,0BAAA;ACHF;;ADMA;EACE,0BAAA;ACHF;;ADMA;EACE,0BAAA;ACHF;;ADMA;EACE,0BAAA;ACHF;;ADMA;EACE,0BAAA;ACHF;;ADMA;EACE,0BAAA;ACHF;;ADMA;EACE,0BAAA;ACHF;;ADMA;EACE,0BAAA;ACHF;;ADMA;EACE,2BAAA;ACHF;;ADMA;EACE,2BAAA;ACHF;;ADMA;EACE,2BAAA;ACHF;;ADMA;EACE,2BAAA;ACHF;;ADOA;EACE,uBAAA;ACJF;;ADOA;EACE,wBAAA;ACJF;;ADOA;EACE,wBAAA;ACJF;;ADOA;EACE,wBAAA;ACJF;;ADOA;EACE,4BAAA;ACJF;;ADOA;EACE,8BAAA;ACJF;;ADOA;EACE,+BAAA;ACJF;;ADOA;EACE,+BAAA;ACJF;;ADOA;EACE,+BAAA;ACJF;;ADOA;EACE,+BAAA;ACJF;;ADOA;EACE,+BAAA;ACJF;;ADOA;EACE,+BAAA;ACJF;;ADOA;EACE,+BAAA;ACJF;;ADOA;EACE,+BAAA;ACJF;;ADOA;EACE,yBAAA;ACJF;;ADOA;EACE,4BAAA;ACJF;;ADOA;EACE,4BAAA;ACJF;;ADOA;EACE,4BAAA;ACJF;;ADOA;EACE,4BAAA;ACJF;;ADOA;EACE,4BAAA;ACJF;;ADOA;EACE,4BAAA;ACJF;;ADOA;EACE,4BAAA;ACJF;;ADOA;EACE,6BAAA;ACJF;;ADOA;EACE,6BAAA;ACJF;;ADOA;EACE,6BAAA;ACJF;;ADOA;EACE,8BAAA;ACJF;;ADOA;EACE,8BAAA;ACJF;;ADOA;EACE,8BAAA;ACJF;;ADOA;EACE,8BAAA;ACJF;;ADOA;EACE,8BAAA;ACJF;;ADQA;EACE,6BAAA;ACLF;;ADQA;EACE,6BAAA;ACLF;;ADQA;EACE,6BAAA;ACLF;;ADQA;EACE,6BAAA;ACLF;;ADQA;EACE,8BAAA;ACLF;;ADQA;EACE,8BAAA;ACLF;;ADQA;EACE,8BAAA;ACLF;;ADQA;EACE,8BAAA;ACLF;;ADQA;EACE,8BAAA;ACLF;;ADQA;EACE,8BAAA;ACLF;;ADQA;EACE,8BAAA;ACLF;;ADQA;EACE,8BAAA;ACLF;;ADQA;EACE,8BAAA;ACLF;;ADQA;EACE,0BAAA;ACLF;;ADQA;EACE,0BAAA;ACLF;;ADQA;EACE,0BAAA;ACLF;;ADQA;EACE,0BAAA;ACLF;;ADQA;EACE,0BAAA;ACLF;;ADQA;EACE,2BAAA;ACLF;;ADQA;EACE,2BAAA;ACLF;;ADQA;EACE,2BAAA;ACLF;;ADQA;EACE,2BAAA;ACLF;;ADQA;EACE,2BAAA;ACLF;;ADQA;EACE,2BAAA;ACLF;;ADQA;EACE,2BAAA;ACLF;;ADQA;EACE,4BAAA;ACLF;;ADQA;EACE,2BAAA;ACLF;;ADQA;EACE,2BAAA;ACLF;;ADQA;EACE,2BAAA;ACLF;;ADQA;EACE,2BAAA;ACLF;;ADQA;EACE,4BAAA;ACLF;;ADQA;EACE,4BAAA;ACLF;;ADQA;EACE,4BAAA;ACLF;;ADQA;EACE,4BAAA;ACLF;;ADQA;EACE,4BAAA;ACLF;;ADQA;EACE,4BAAA;ACLF;;ADQA;EACE,4BAAA;ACLF;;ADQA;EACE,4BAAA;ACLF;;ADQA;EACE,6BAAA;ACLF;;ADQA;EACE,6BAAA;ACLF;;ADQA;EACE,6BAAA;ACLF;;ADQA;EACE,6BAAA;ACLF;;ADQA;EACE,6BAAA;ACLF;;ADQA;EACE,6BAAA;ACLF;;ADSA;EACE,6BAAA;ACNF;;ADSA;EACE,6BAAA;ACNF;;ADSA;EACE,6BAAA;ACNF;;ADSA;EACE,8BAAA;ACNF;;ADSA;EACE,8BAAA;ACNF;;ADSA;EACE,8BAAA;ACNF;;ADSA;EACE,6BAAA;ACNF;;ADSA;EACE,uCAAA;ACNF;;ADSA;EACE,8CAAA;ACNF;;ADSA;EACE,2CAAA;ACNF;;ADSA;EACE,4CAAA;ACNF;;ADSA;EACE,6CAAA;ACNF;;ADSA;EACE,yBAAA;ACNF;;ADSA;EACE,gCAAA;ACNF;;ADSA;EACE,6BAAA;ACNF;;ADSA;EACE,8BAAA;ACNF;;ADSA;EACE,+BAAA;ACNF;;ADUA;EACE,iBAAA;ACPF;;ADUA;EACE,mBAAA;ACPF;;ADUA;EACE,mBAAA;ACPF;;ADUA;EACE,mBAAA;ACPF;;ADUA;EACE,mBAAA;ACPF;;ADUA;EACE,mBAAA;ACPF;;ADUA;EACE,oBAAA;ACPF;;ADUA;EACE,oBAAA;ACPF;;ADUA;EACE,oBAAA;ACPF;;ADUA;EACE,oBAAA;ACPF;;ADUA;EACE,oBAAA;ACPF;;ADUA;EACE,oBAAA;ACPF;;ADUA;EACE,oBAAA;ACPF;;ADUA;EACE,oBAAA;ACPF;;ADUA;EACE,oBAAA;ACPF;;ADUA;EACE,oBAAA;ACPF;;ADUA;EACE,oBAAA;ACPF;;ADUA;EACE,oBAAA;ACPF;;ADUA;EACE,OAAA;ACPF;;ADUA;EACE,qBAAA;ACPF;;ADUA;EACE,aAAA;EACA,iCAAA;ACPF;;ADUA;EACE,aAAA;EACA,8BAAA;ACPF;;ADUA;EACE,aAAA;EACA,8BAAA;ACPF;;ADUA;EACE,aAAA;EACA,kCAAA;ACPF;;ADUA;EACE,aAAA;EACA,+BAAA;ACPF;;ADUA;EACE,aAAA;EACA,6BAAA;ACPF;;ADUA;EACE,aAAA;EACA,yCAAA;ACPF;;ADUA;EACE,0BAAA;ACPF;;ADWA;EACE,YAAA;ACRF;;ADWA;EACE,qBAAA;ACRF;;ADWA;EACE,WAAA;ACRF;;ADYA;EACE,eAAA;ACTF;;ADYA;EACE,8BAAA;ACTF;;ADaA;EACE,QAAA;EACA,SAAA;EACA,kBAAA;EACA,gCAAA;ACVF;;ADaA;EACE,kBAAA;ACVF;;ADaA;EACE,kBAAA;ACVF;;ADaA;EACE,eAAA;ACVF;;ADcA;EACE,UAAA;ACXF;;ADcA;EACE,UAAA;ACXF;;ADeA;EACE,qBAAA;ACZF;;ADeA;EACE,sBAAA;ACZF;;ADgBA;EACE,SAAA;EACA,qBAAA;EACA,2BAAA;ACbF;;ADgBA;EE5lBE,wLF8lBE;EE7lBF,kBAAA;EACA,kBAAA;ADglBF;AC9kBE;EACE,oCAAA;EACA,mBAAA;ADglBJ;AC7kBE;EACE,UAAA;EACA,6BAAA;AD+kBJ;AC5kBE;EACE,aAAA;AD8kBJ;ADQE;EErmBA,8JFumBI;EEtmBJ,kBAAA;EACA,kBAAA;ADgmBF;AC9lBE;EACE,oCAAA;EACA,mBAAA;ADgmBJ;AC7lBE;EACE,UAAA;EACA,6BAAA;AD+lBJ;AC5lBE;EACE,aAAA;AD8lBJ;;ADGA;EACE,6BAAA;ACAF;;ADIA;EACE,WAAA;EACA,YAAA;EACA,eAAA;ACDF;;ADIA;EACE,WAAA;EACA,YAAA;EACA,kBAAA;ACDF;;ADIA;EACE,iBAAA;ACDF;;ADIA;EACE,sBAAA;ACDF;;ADIA;EACE,aAAA;EACA,kBAAA;EACA,eAAA;EACA,gBAAA;EACA,eAAA;EACA,iBAAA;EACA,cAAA;ACDF;;ADIA;EACE,0BAAA;ACDF;;AA3pBA;EACE,kBAAA;ECOA,2GDLE;ECMF,kBAAA;EACA,kBAAA;ADwpBF;ACtpBE;EACE,oCAAA;EACA,mBAAA;ADwpBJ;ACrpBE;EACE,UAAA;EACA,6BAAA;ADupBJ;ACppBE;EACE,aAAA;ADspBJ;AArqBE;EACE,UAAA;AAuqBJ","sourcesContent":["@use 'mixins';\n@use 'functions';\n\n// font\n.font-s-10 {\n  font-size: 10px !important;\n}\n\n.font-s-12 {\n  font-size: 12px !important;\n}\n\n.font-s-13 {\n  font-size: 13px !important;\n}\n\n.font-s-14 {\n  font-size: 14px !important;\n}\n\n.font-s-15 {\n  font-size: 15px !important;\n}\n\n.font-s-16 {\n  font-size: 16px !important;\n}\n\n.font-s-18 {\n  font-size: 18px !important;\n}\n\n.font-s-20 {\n  font-size: 20px !important;\n}\n\n.font-s-22 {\n  font-size: 22px !important;\n}\n\n.font-s-28 {\n  font-size: 28px !important;\n}\n\n.font-w-400 {\n  font-weight: 400 !important;\n}\n\n.font-w-500 {\n  font-weight: 500 !important;\n}\n\n.font-w-600 {\n  font-weight: 600 !important;\n}\n\n.font-w-700 {\n  font-weight: 700 !important;\n}\n\n// padding\n.p-5 {\n  padding: 5px !important;\n}\n\n.p-12 {\n  padding: 12px !important;\n}\n\n.p-16 {\n  padding: 16px !important;\n}\n\n.p-30 {\n  padding: 30px !important;\n}\n\n.p-b-0 {\n  padding-bottom: 0 !important;\n}\n\n.p-b-5 {\n  padding-bottom: 5px !important;\n}\n\n.p-b-10 {\n  padding-bottom: 10px !important;\n}\n\n.p-b-12 {\n  padding-bottom: 12px !important;\n}\n\n.p-b-16 {\n  padding-bottom: 16px !important;\n}\n\n.p-b-18 {\n  padding-bottom: 18px !important;\n}\n\n.p-b-20 {\n  padding-bottom: 20px !important;\n}\n\n.p-b-25 {\n  padding-bottom: 25px !important;\n}\n\n.p-b-30 {\n  padding-bottom: 30px !important;\n}\n\n.p-b-50 {\n  padding-bottom: 50px !important;\n}\n\n.p-t-0 {\n  padding-top: 0 !important;\n}\n\n.p-t-12 {\n  padding-top: 12px !important;\n}\n\n.p-t-16 {\n  padding-top: 16px !important;\n}\n\n.p-t-18 {\n  padding-top: 18px !important;\n}\n\n.p-t-20 {\n  padding-top: 20px !important;\n}\n\n.p-t-30 {\n  padding-top: 30px !important;\n}\n\n.p-t-40 {\n  padding-top: 40px !important;\n}\n\n.p-t-50 {\n  padding-top: 50px !important;\n}\n\n.p-l-20 {\n  padding-left: 20px !important;\n}\n\n.p-l-30 {\n  padding-left: 30px !important;\n}\n\n.p-l-40 {\n  padding-left: 40px !important;\n}\n\n.p-r-16 {\n  padding-right: 16px !important;\n}\n\n.p-r-20 {\n  padding-right: 20px !important;\n}\n\n.p-r-30 {\n  padding-right: 30px !important;\n}\n\n.p-r-50 {\n  padding-right: 50px !important;\n}\n\n.p-r-60 {\n  padding-right: 60px !important;\n}\n\n// margin\n.m-b-1 {\n  margin-bottom: 1px !important;\n}\n\n.m-b-2 {\n  margin-bottom: 2px !important;\n}\n\n.m-b-6 {\n  margin-bottom: 6px !important;\n}\n\n.m-b-8 {\n  margin-bottom: 8px !important;\n}\n\n.m-b-10 {\n  margin-bottom: 10px !important;\n}\n\n.m-b-14 {\n  margin-bottom: 14px !important;\n}\n\n.m-b-16 {\n  margin-bottom: 16px !important;\n}\n\n.m-b-20 {\n  margin-bottom: 20px !important;\n}\n\n.m-b-22 {\n  margin-bottom: 22px !important;\n}\n\n.m-b-24 {\n  margin-bottom: 24px !important;\n}\n\n.m-b-30 {\n  margin-bottom: 30px !important;\n}\n\n.m-b-32 {\n  margin-bottom: 32px !important;\n}\n\n.m-b-40 {\n  margin-bottom: 40px !important;\n}\n\n.m-t-2 {\n  margin-top: 2px !important;\n}\n\n.m-t-3 {\n  margin-top: 3px !important;\n}\n\n.m-t-4 {\n  margin-top: 4px !important;\n}\n\n.m-t-5 {\n  margin-top: 5px !important;\n}\n\n.m-t-8 {\n  margin-top: 8px !important;\n}\n\n.m-t-10 {\n  margin-top: 10px !important;\n}\n\n.m-t-15 {\n  margin-top: 15px !important;\n}\n\n.m-t-16 {\n  margin-top: 16px !important;\n}\n\n.m-t-20 {\n  margin-top: 20px !important;\n}\n\n.m-t-22 {\n  margin-top: 22px !important;\n}\n\n.m-t-30 {\n  margin-top: 30px !important;\n}\n\n.m-t-32 {\n  margin-top: 32px !important;\n}\n\n.m-l-auto {\n  margin-left: auto !important;\n}\n\n.m-l-4 {\n  margin-left: 4px !important;\n}\n\n.m-l-5 {\n  margin-left: 5px !important;\n}\n\n.m-l-6 {\n  margin-left: 6px !important;\n}\n\n.m-l-8 {\n  margin-left: 8px !important;\n}\n\n.m-l-10 {\n  margin-left: 10px !important;\n}\n\n.m-l-16 {\n  margin-left: 16px !important;\n}\n\n.m-l-20 {\n  margin-left: 20px !important;\n}\n\n.m-l-24 {\n  margin-left: 24px !important;\n}\n\n.m-l-30 {\n  margin-left: 30px !important;\n}\n\n.m-l-35 {\n  margin-left: 35px !important;\n}\n\n.m-l-40 {\n  margin-left: 40px !important;\n}\n\n.m-r-8 {\n  margin-right: 8px !important;\n}\n\n.m-r-10 {\n  margin-right: 10px !important;\n}\n\n.m-r-16 {\n  margin-right: 16px !important;\n}\n\n.m-r-20 {\n  margin-right: 20px !important;\n}\n\n.m-r-24 {\n  margin-right: 24px !important;\n}\n\n.m-r-30 {\n  margin-right: 30px !important;\n}\n\n.m-r-40 {\n  margin-right: 40px !important;\n}\n\n// border\n.border-r-3 {\n  border-radius: 3px !important;\n}\n\n.border-r-4 {\n  border-radius: 4px !important;\n}\n\n.border-r-6 {\n  border-radius: 6px !important;\n}\n\n.border-r-10 {\n  border-radius: 10px !important;\n}\n\n.border-r-12 {\n  border-radius: 12px !important;\n}\n\n.border-r-16 {\n  border-radius: 16px !important;\n}\n\n.border-r-50 {\n  border-radius: 50% !important;\n}\n\n.primary-border {\n  border: 1px solid rgba(91, 91, 91, 0.2);\n}\n\n.primary-border-b {\n  border-bottom: 1px solid rgba(91, 91, 91, 0.2);\n}\n\n.primary-border-t {\n  border-top: 1px solid rgba(91, 91, 91, 0.2);\n}\n\n.primary-border-l {\n  border-left: 1px solid rgba(91, 91, 91, 0.2);\n}\n\n.primary-border-r {\n  border-right: 1px solid rgba(91, 91, 91, 0.2);\n}\n\n.secondary-border {\n  border: 1px solid functions.get-color(greenNew, medium-dark);\n}\n\n.secondary-border-b {\n  border-bottom: 1px solid functions.get-color(greenNew, medium-dark);\n}\n\n.secondary-border-t {\n  border-top: 1px solid functions.get-color(greenNew, medium-dark);\n}\n\n.secondary-border-l {\n  border-left: 1px solid functions.get-color(greenNew, medium-dark);\n}\n\n.secondary-border-r {\n  border-right: 1px solid functions.get-color(greenNew, medium-dark);\n}\n\n// flex\n.gap-0 {\n  gap: 0 !important;\n}\n\n.gap-2 {\n  gap: 2px !important;\n}\n\n.gap-4 {\n  gap: 4px !important;\n}\n\n.gap-5 {\n  gap: 5px !important;\n}\n\n.gap-6 {\n  gap: 6px !important;\n}\n\n.gap-8 {\n  gap: 8px !important;\n}\n\n.gap-10 {\n  gap: 10px !important;\n}\n\n.gap-12 {\n  gap: 12px !important;\n}\n\n.gap-14 {\n  gap: 14px !important;\n}\n\n.gap-16 {\n  gap: 16px !important;\n}\n\n.gap-18 {\n  gap: 18px !important;\n}\n\n.gap-20 {\n  gap: 20px !important;\n}\n\n.gap-24 {\n  gap: 24px !important;\n}\n\n.gap-26 {\n  gap: 26px !important;\n}\n\n.gap-30 {\n  gap: 30px !important;\n}\n\n.gap-32 {\n  gap: 32px !important;\n}\n\n.gap-40 {\n  gap: 40px !important;\n}\n\n.gap-50 {\n  gap: 50px !important;\n}\n\n.flex-1 {\n  flex: 1;\n}\n\n.flex-none {\n  flex: none !important;\n}\n\n.flex-column {\n  display: flex;\n  flex-direction: column !important;\n}\n\n.flex-row {\n  display: flex;\n  flex-direction: row !important;\n}\n\n.vertically-centered {\n  display: flex;\n  align-items: center !important;\n}\n\n.horizontally-centered {\n  display: flex;\n  justify-content: center !important;\n}\n\n.horizontally-end {\n  display: flex;\n  justify-content: end !important;\n}\n\n.vertically-start {\n  display: flex;\n  align-items: start !important;\n}\n\n.space-between {\n  display: flex;\n  justify-content: space-between !important;\n}\n\n.flex-wrap {\n  flex-wrap: wrap !important;\n}\n\n// width and height\n.height-100 {\n  height: 100%;\n}\n\n.width-50 {\n  width: 50% !important;\n}\n\n.width-100 {\n  width: 100%;\n}\n\n// cursor\n.cursor-pointer {\n  cursor: pointer;\n}\n\n.cursor-not-allowed {\n  cursor: not-allowed !important;\n}\n\n// position\n.absolute-centered {\n  top: 50%;\n  left: 50%;\n  position: absolute;\n  transform: translate(-50%, -50%);\n}\n\n.absolute {\n  position: absolute;\n}\n\n.relative {\n  position: relative;\n}\n\n.fixed {\n  position: fixed;\n}\n\n// visibility\n.visible {\n  opacity: 1;\n}\n\n.invisible {\n  opacity: 0;\n}\n\n// layout\n.col-90 {\n  width: 90% !important;\n}\n\n.col-auto {\n  width: auto !important;\n}\n\n// medical fragments\n.medical-tabs {\n  gap: 30px;\n  padding: 0 !important;\n  margin: 20px 40px -5px 40px;\n}\n\n.medical-table-new {\n  @include mixins.verticalScroll(\n    calc(\n      100vh - var(--tabs-navigation) - var(--patient-details-header) - var(\n          --secondary-navigation\n        ) - var(--patient-details-footer) - var(--table-tabs) - var(--table-pagination)\n    )\n  );\n\n  &.no-pagination {\n    @include mixins.verticalScroll(\n      calc(\n        100vh - var(--tabs-navigation) - var(--patient-details-header) - var(\n            --secondary-navigation\n          ) - var(--patient-details-footer) - var(--table-tabs)\n      )\n    );\n  }\n}\n\n.medical-table-empty {\n  padding: 14px 40px !important;\n}\n\n//\n.icon-btn {\n  width: 22px;\n  height: 22px;\n  cursor: pointer;\n}\n\n.search-icon {\n  width: 24px;\n  height: 24px;\n  align-self: center;\n}\n\n.disable-select {\n  user-select: none;\n}\n\n.break-word {\n  word-break: break-word;\n}\n\n.popup-clear-btn {\n  display: flex;\n  align-self: center;\n  cursor: pointer;\n  font-weight: 500;\n  font-size: 14px;\n  line-height: 150%;\n  color: functions.get-color(redNew, medium-dark);\n}\n\n.scroll-m-b-20 {\n  scroll-margin-bottom: 20px;\n}\n","@use 'common-src/styles/global' as *;\n\n.article {\n  padding: 27px 24px;\n  @include verticalScroll(\n    calc(\n      100vh - var(--top-navigation) - var(--patient-details-header) - var(--patient-details-footer)\n    )\n  );\n\n  .acccordion {\n    width: 70%;\n  }\n}\n","@forward 'sizes';\n@forward 'variables';\n\n@mixin clipped-text {\n  overflow: hidden;\n  white-space: nowrap;\n  text-overflow: ellipsis;\n}\n\n@mixin verticalScroll($height) {\n  height: $height;\n  overflow-y: scroll;\n  overflow-x: hidden;\n\n  &:hover::-webkit-scrollbar-thumb {\n    background-color: rgb(125, 123, 121);\n    border-radius: 10px;\n  }\n\n  &::-webkit-scrollbar {\n    width: 5px;\n    background-color: transparent;\n  }\n\n  &::-webkit-scrollbar-track {\n    display: none;\n  }\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"fontS10": `Contacts-module__font-s-10___dTxB_`,
	"fontS12": `Contacts-module__font-s-12___kMUAT`,
	"fontS13": `Contacts-module__font-s-13___pVCA8`,
	"fontS14": `Contacts-module__font-s-14___uoVcI`,
	"fontS15": `Contacts-module__font-s-15___iCfW4`,
	"fontS16": `Contacts-module__font-s-16___nynmc`,
	"fontS18": `Contacts-module__font-s-18___Ba5pN`,
	"fontS20": `Contacts-module__font-s-20___t7Ql8`,
	"fontS22": `Contacts-module__font-s-22___yF26Z`,
	"fontS28": `Contacts-module__font-s-28___i9XM0`,
	"fontW400": `Contacts-module__font-w-400___chQ9C`,
	"fontW500": `Contacts-module__font-w-500___YSarm`,
	"fontW600": `Contacts-module__font-w-600___rmu7r`,
	"fontW700": `Contacts-module__font-w-700___pHpAg`,
	"p5": `Contacts-module__p-5___kurs7`,
	"p12": `Contacts-module__p-12___woYUp`,
	"p16": `Contacts-module__p-16___Xrj6m`,
	"p30": `Contacts-module__p-30___x5k78`,
	"pB0": `Contacts-module__p-b-0___tho9A`,
	"pB5": `Contacts-module__p-b-5___oN6We`,
	"pB10": `Contacts-module__p-b-10___uk488`,
	"pB12": `Contacts-module__p-b-12___h96G4`,
	"pB16": `Contacts-module__p-b-16___uvvDh`,
	"pB18": `Contacts-module__p-b-18___vcST3`,
	"pB20": `Contacts-module__p-b-20___WeC2o`,
	"pB25": `Contacts-module__p-b-25___qcF5Y`,
	"pB30": `Contacts-module__p-b-30___XNEST`,
	"pB50": `Contacts-module__p-b-50____LH6d`,
	"pT0": `Contacts-module__p-t-0___ioSxG`,
	"pT12": `Contacts-module__p-t-12___F__MH`,
	"pT16": `Contacts-module__p-t-16___ojqiQ`,
	"pT18": `Contacts-module__p-t-18___WV29x`,
	"pT20": `Contacts-module__p-t-20___QQunH`,
	"pT30": `Contacts-module__p-t-30___sHV35`,
	"pT40": `Contacts-module__p-t-40___fka4m`,
	"pT50": `Contacts-module__p-t-50___D5r6Q`,
	"pL20": `Contacts-module__p-l-20___bseIP`,
	"pL30": `Contacts-module__p-l-30___w0vtR`,
	"pL40": `Contacts-module__p-l-40___ysIcg`,
	"pR16": `Contacts-module__p-r-16___YRmPG`,
	"pR20": `Contacts-module__p-r-20___PDmtm`,
	"pR30": `Contacts-module__p-r-30___JfdYz`,
	"pR50": `Contacts-module__p-r-50___cUTB8`,
	"pR60": `Contacts-module__p-r-60___r6RId`,
	"mB1": `Contacts-module__m-b-1___bhWJO`,
	"mB2": `Contacts-module__m-b-2___uQz9H`,
	"mB6": `Contacts-module__m-b-6___sDLvL`,
	"mB8": `Contacts-module__m-b-8___UAmSz`,
	"mB10": `Contacts-module__m-b-10___oFvcG`,
	"mB14": `Contacts-module__m-b-14___jXSgZ`,
	"mB16": `Contacts-module__m-b-16___TBYem`,
	"mB20": `Contacts-module__m-b-20___SsmDP`,
	"mB22": `Contacts-module__m-b-22___SExx4`,
	"mB24": `Contacts-module__m-b-24___zgkcS`,
	"mB30": `Contacts-module__m-b-30___DZCTO`,
	"mB32": `Contacts-module__m-b-32___dsm76`,
	"mB40": `Contacts-module__m-b-40___Vg3b9`,
	"mT2": `Contacts-module__m-t-2___BsKXe`,
	"mT3": `Contacts-module__m-t-3___HN4pW`,
	"mT4": `Contacts-module__m-t-4___rGKFm`,
	"mT5": `Contacts-module__m-t-5___NdTfu`,
	"mT8": `Contacts-module__m-t-8___oR8y3`,
	"mT10": `Contacts-module__m-t-10___TPvZT`,
	"mT15": `Contacts-module__m-t-15___UBmkK`,
	"mT16": `Contacts-module__m-t-16___iqy3W`,
	"mT20": `Contacts-module__m-t-20___r6g9t`,
	"mT22": `Contacts-module__m-t-22___S_d77`,
	"mT30": `Contacts-module__m-t-30___QweLQ`,
	"mT32": `Contacts-module__m-t-32____bgBz`,
	"mLAuto": `Contacts-module__m-l-auto___VytvD`,
	"mL4": `Contacts-module__m-l-4___fAKiH`,
	"mL5": `Contacts-module__m-l-5___WnKy4`,
	"mL6": `Contacts-module__m-l-6___x1Kpi`,
	"mL8": `Contacts-module__m-l-8___ADyIq`,
	"mL10": `Contacts-module__m-l-10___Zs7E0`,
	"mL16": `Contacts-module__m-l-16___dpuzX`,
	"mL20": `Contacts-module__m-l-20___peoby`,
	"mL24": `Contacts-module__m-l-24___akVMZ`,
	"mL30": `Contacts-module__m-l-30___DzmGk`,
	"mL35": `Contacts-module__m-l-35___b8VC2`,
	"mL40": `Contacts-module__m-l-40___zVzWE`,
	"mR8": `Contacts-module__m-r-8___z4zEO`,
	"mR10": `Contacts-module__m-r-10___TNs5y`,
	"mR16": `Contacts-module__m-r-16___Qe3gf`,
	"mR20": `Contacts-module__m-r-20___TGDSi`,
	"mR24": `Contacts-module__m-r-24___ZlovK`,
	"mR30": `Contacts-module__m-r-30___O5Yc8`,
	"mR40": `Contacts-module__m-r-40____XsFw`,
	"borderR3": `Contacts-module__border-r-3____oDPj`,
	"borderR4": `Contacts-module__border-r-4___RVzr9`,
	"borderR6": `Contacts-module__border-r-6___COYOl`,
	"borderR10": `Contacts-module__border-r-10___ReZNR`,
	"borderR12": `Contacts-module__border-r-12___bxdJG`,
	"borderR16": `Contacts-module__border-r-16___wucYt`,
	"borderR50": `Contacts-module__border-r-50___SuuVU`,
	"primaryBorder": `Contacts-module__primary-border___Hzbwx`,
	"primaryBorderB": `Contacts-module__primary-border-b___yAXz_`,
	"primaryBorderT": `Contacts-module__primary-border-t___pJFW5`,
	"primaryBorderL": `Contacts-module__primary-border-l___GfK1Y`,
	"primaryBorderR": `Contacts-module__primary-border-r___tCxMF`,
	"secondaryBorder": `Contacts-module__secondary-border___S8qW9`,
	"secondaryBorderB": `Contacts-module__secondary-border-b___rmvVb`,
	"secondaryBorderT": `Contacts-module__secondary-border-t___L3tbP`,
	"secondaryBorderL": `Contacts-module__secondary-border-l___cbb8S`,
	"secondaryBorderR": `Contacts-module__secondary-border-r___AktX5`,
	"gap0": `Contacts-module__gap-0___TxD_p`,
	"gap2": `Contacts-module__gap-2___RZHDW`,
	"gap4": `Contacts-module__gap-4___SCbye`,
	"gap5": `Contacts-module__gap-5___cMpjD`,
	"gap6": `Contacts-module__gap-6___JQlr4`,
	"gap8": `Contacts-module__gap-8___wVc20`,
	"gap10": `Contacts-module__gap-10___woTae`,
	"gap12": `Contacts-module__gap-12___ncJVd`,
	"gap14": `Contacts-module__gap-14___AfvKK`,
	"gap16": `Contacts-module__gap-16___sAjZP`,
	"gap18": `Contacts-module__gap-18___V2NXE`,
	"gap20": `Contacts-module__gap-20___qf1MT`,
	"gap24": `Contacts-module__gap-24___EjS08`,
	"gap26": `Contacts-module__gap-26___LjXIL`,
	"gap30": `Contacts-module__gap-30___RMU1S`,
	"gap32": `Contacts-module__gap-32___FDDET`,
	"gap40": `Contacts-module__gap-40___elrx8`,
	"gap50": `Contacts-module__gap-50___fa8B8`,
	"flex1": `Contacts-module__flex-1___czmF5`,
	"flexNone": `Contacts-module__flex-none___rg5q3`,
	"flexColumn": `Contacts-module__flex-column___f3zK4`,
	"flexRow": `Contacts-module__flex-row___yPGR4`,
	"verticallyCentered": `Contacts-module__vertically-centered___JnD58`,
	"horizontallyCentered": `Contacts-module__horizontally-centered___TdSJX`,
	"horizontallyEnd": `Contacts-module__horizontally-end___rACcc`,
	"verticallyStart": `Contacts-module__vertically-start___WXZFv`,
	"spaceBetween": `Contacts-module__space-between____8aWf`,
	"flexWrap": `Contacts-module__flex-wrap___i2ioB`,
	"height100": `Contacts-module__height-100___CC5lC`,
	"width50": `Contacts-module__width-50___DX4tM`,
	"width100": `Contacts-module__width-100___XDdWK`,
	"cursorPointer": `Contacts-module__cursor-pointer___wIFQe`,
	"cursorNotAllowed": `Contacts-module__cursor-not-allowed___i4XEi`,
	"absoluteCentered": `Contacts-module__absolute-centered___KbWru`,
	"absolute": `Contacts-module__absolute___KYdvk`,
	"relative": `Contacts-module__relative___pgq7z`,
	"fixed": `Contacts-module__fixed___pUUKD`,
	"visible": `Contacts-module__visible___d4RTI`,
	"invisible": `Contacts-module__invisible___sretV`,
	"col90": `Contacts-module__col-90___LPS8u`,
	"colAuto": `Contacts-module__col-auto___GiZDh`,
	"medicalTabs": `Contacts-module__medical-tabs____pBVh`,
	"medicalTableNew": `Contacts-module__medical-table-new___D5mkP`,
	"noPagination": `Contacts-module__no-pagination___Ry7oR`,
	"medicalTableEmpty": `Contacts-module__medical-table-empty___p0kbn`,
	"iconBtn": `Contacts-module__icon-btn___iJ63s`,
	"searchIcon": `Contacts-module__search-icon___rVWVu`,
	"disableSelect": `Contacts-module__disable-select___ZcfT0`,
	"breakWord": `Contacts-module__break-word___Mm52r`,
	"popupClearBtn": `Contacts-module__popup-clear-btn___GQYFq`,
	"scrollMB20": `Contacts-module__scroll-m-b-20___eVjve`,
	"article": `Contacts-module__article___FZan8`,
	"acccordion": `Contacts-module__acccordion____f03t`
};
module.exports = ___CSS_LOADER_EXPORT___;
